<div>
  <h2>Qui serait notifié ?</h2>
  <p class="hint">
    Choisissez un cas pour voir les lignes qui s'appliquent et les personnes qu'elles désignent
    aujourd'hui. Un critère laissé vide vaut « aucun ».
  </p>
</div>

<div class="query" [formGroup]="form">
  <mat-form-field>
    <mat-label>Société</mat-label>
    <mat-select formControlName="companyId">
      <mat-option [value]="null">Aucune</mat-option>
      @for (company of companies(); track company.id) {
        <mat-option [value]="company.id">{{ company.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Type de contrat</mat-label>
    <mat-select formControlName="contractType">
      <mat-option [value]="null">Aucun</mat-option>
      @for (contractType of contractTypes; track contractType) {
        <mat-option [value]="contractType">{{ contractType }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (setting().precision === 'VALIDATION_TYPE') {
    <mat-form-field>
      <mat-label>Échelon</mat-label>
      <mat-select formControlName="validationType">
        <mat-option [value]="null">Aucun</mat-option>
        @for (validationType of validationTypes; track validationType) {
          <mat-option [value]="validationType">{{
            validationType | validationRequestTypeLabel
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  @if (setting().precision === 'DOCUMENT_TAG') {
    <mat-form-field>
      <mat-label>Document</mat-label>
      <mat-select formControlName="documentTag">
        <mat-option [value]="null">Aucun</mat-option>
        @for (tag of documentTags; track tag) {
          <mat-option [value]="tag">{{ documentTagLabels[tag] }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>

@if (preview(); as preview) {
  <div class="results">
    <div class="box" data-section="lines">
      <h3>Lignes qui s'appliquent</h3>
      @for (line of preview.lines; track line.id) {
        <div class="applied-line">
          <div>
            <span class="line-name">{{ lineLabel(line.id) }}</span>
            <span class="hint">{{ criteria(line) }}</span>
          </div>
          <app-designation-chips
            [designations]="line.designations"
            emptyLabel="N'ajoute personne"
          ></app-designation-chips>
        </div>
      }
      <p class="hint">Elles cumulent leurs destinataires ; aucune n'en retire.</p>
    </div>

    <div class="box wide">
      <div data-section="recipients">
        <h3>Personnes désignées</h3>
        @if (nobody()) {
          <p class="nobody">Personne ne serait notifié dans ce cas.</p>
        }
        <ul>
          @for (person of preview.recipients; track person.userId) {
            <li>
              <span>{{ personName(person) }}</span>
              @for (reason of person.reasons; track $index) {
                <span class="reason" [class.subscribed]="reason.subscription">{{
                  reasonLabel(reason)
                }}</span>
              }
            </li>
          }
        </ul>
      </div>

      @if (preview.relations.length) {
        <div data-section="relations">
          <h4>Relations au contrat</h4>
          <p class="hint">
            Elles désignent une personne sur chaque contrat ; l'aperçu les nomme sans les résoudre.
          </p>
          <ul>
            @for (relation of preview.relations; track $index) {
              <li>
                <span>{{ relationLabels[relation.relation] }}</span>
                <span class="reason">{{ lineLabel(relation.lineId) }}</span>
              </li>
            }
          </ul>
        </div>
      }

      @if (preview.unsubscribed.length) {
        <div data-section="unsubscribed">
          <h4>Se retirent</h4>
          <ul>
            @for (person of preview.unsubscribed; track person.userId) {
              <li>
                <span class="struck">{{ personName(person) }}</span>
                <span class="reason unsubscribed">Se retire par son abonnement</span>
              </li>
            }
          </ul>
        </div>
      }

      @if (preview.withoutEmail.length) {
        <div data-section="without-email">
          <h4>Écartées</h4>
          <ul>
            @for (person of preview.withoutEmail; track person.userId) {
              <li>
                <span class="discarded">{{ personName(person) }}</span>
                <span class="reason">Pas d'adresse de courriel — écartée</span>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
}
